import { Component, OnInit } from '@angular/core';
import { FarmService } from 'src/app/services/farm-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProcessService } from 'src/app/services/process.service';
import { ActivatedRoute, Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'smart-config-sensor',
  templateUrl: './config-sensor.component.html',
  styleUrls: ['./config-sensor.component.scss']
})
export class ConfigSensorComponent implements OnInit {

  data: any;
  farmId: any;
  plotId: any;
  dataSensor: any = [];

  constructor(
    private spinner: NgxSpinnerService,
    private processService: ProcessService,
    private router: Router,
    private route: ActivatedRoute,
  ) {

  }

  ngOnInit(): void {
    // this.getSocket()

    this.route.params.subscribe(routeParams => {
      window.scroll(0, 0);
      //window.scroll(0, 1000);
      this.farmId = routeParams["farm"];
      this.plotId = routeParams["plot"];

    });
    sessionStorage.setItem("farmmenu", this.farmId);
    sessionStorage.setItem("plotmenu", this.plotId);

  }

  async updateSensor() {
  }

  // getSocket() {

  //   let arrSensor = [];
  //   this.processService.messages.subscribe(async (msg) => {
  //     this.data = msg;
  //     // this.data = msg.data[0].Plot[0].things[0].sensor[0];
  //     // console.log("<===this.data===>", this.data);
  //     if (msg.data) {
  //       msg.data.forEach(element => {
  //         // ////console.log("element",element);
  //         if (element._id == this.farmId) {
  //           //console.log("mes===>",element);
  //           element.Plot.forEach(elementp => {
  //             if (elementp._id == this.plotId) {
  //               // console.log("this.plotId==>>>>", this.plotId);
  //               if (elementp.thing[0] != undefined) {
  //                 // console.log("elementp.thing==>>>>",elementp.thing);
  //                 this.getSensor(elementp.thing);
  //                 this.dataSensor.forEach((elementS, index) => {

  //                   if (elementS.lastValue == undefined) {
  //                     // elementS.lastValue = "0";
  //                   }

  //                   arrSensor.push({
  //                     id: elementS._id,
  //                     lastValue: elementS.lastValue,
  //                     sensor_desc: elementS.sensor_desc,
  //                     last_update: elementS.last_update,
  //                     color: elementS.color
  //                   })

  //                   //this.dataSensor = arrSensor;

  //                 });
  //               }
  //             }
  //           })
  //         }
  //       })
  //     }

  //   })
  //   // console.log(".....this.dataSensor......", arrSensor);
  // }
  getSensor(data) {

    this.spinner.show();
    setTimeout(async () => {
      //  console.log("::dataSensor::",data);

      let arrSensor = [];
      data.forEach(element => {
        element.sensor.forEach((elementS, index) => {
          if (elementS.plot_id != null) {
            if (index < 2) {
              arrSensor.push(elementS)
            }
          }
        });
      });

      //console.log("arrSensor<>><><><><><>",arrSensor);

      this.dataSensor = arrSensor;
      // console.log("this.dataSensor=====>", this.dataSensor);
      for (let index = 0; index < arrSensor.length; index++) {
        const elementSensor = arrSensor[index];
        // if (elementSensor.lastValue == "null") {
        //   elementSensor.lastValue = "0";
        // }

      }


      this.spinner.hide();
    }, 1);
  }

}
